/* @sp/design-tokens — barrel
 *
 * The CSS tokens are the source of truth; this barrel exposes:
 *   - the Tailwind preset (typed Config)
 *   - typed constants for runtime token lookup (e.g. uPlot color resolver)
 *
 * The actual CSS lives in src/tokens.css — consumers import that file
 * directly (Vite/PostCSS handles it), no JS bundling needed.
 */
export { default as tailwindPreset } from './tailwind-preset.js';
/** CSS variable names — useful when imperatively setting styles. */
export const TOKEN_VARS = {
    // Backgrounds
    bgBase: '--bg-base',
    bgSurface: '--bg-surface',
    bgSunken: '--bg-sunken',
    bgElevated: '--bg-elevated',
    // Ink
    inkPrimary: '--ink-primary',
    inkSecondary: '--ink-secondary',
    inkTertiary: '--ink-tertiary',
    inkQuaternary: '--ink-quaternary',
    borderHairline: '--border-hairline',
    // Brand accent (overridable via --brand-accent)
    accent: '--accent',
    accentHover: '--accent-hover',
    accentSoft: '--accent-soft',
    accentInk: '--accent-ink',
    brandAccent: '--brand-accent',
    // Signal
    signalOk: '--signal-ok',
    signalWatch: '--signal-watch',
    signalWarn: '--signal-warn',
    signalAlarm: '--signal-alarm',
};
/** Resolve a Tone to its concrete CSS color value from live DOM.
 *  Returns empty string on SSR — callers must handle that. */
export function readToneColor(tone) {
    if (typeof document === 'undefined')
        return '';
    const root = getComputedStyle(document.documentElement);
    switch (tone) {
        case 'coral': return root.getPropertyValue(TOKEN_VARS.accent).trim();
        case 'ink': return root.getPropertyValue(TOKEN_VARS.inkPrimary).trim();
        case 'neutral': return root.getPropertyValue(TOKEN_VARS.inkQuaternary).trim();
        case 'ok': return root.getPropertyValue(TOKEN_VARS.signalOk).trim();
        case 'watch': return root.getPropertyValue(TOKEN_VARS.signalWatch).trim();
        case 'warn': return root.getPropertyValue(TOKEN_VARS.signalWarn).trim();
        case 'alarm': return root.getPropertyValue(TOKEN_VARS.signalAlarm).trim();
    }
}
/** Apply tenant branding to :root. Call once after auth. */
export function applyTenantBranding(branding) {
    if (typeof document === 'undefined' || !branding)
        return;
    const root = document.documentElement;
    if (branding.colorPrimary) {
        root.style.setProperty(TOKEN_VARS.brandAccent, branding.colorPrimary);
    }
    else {
        root.style.removeProperty(TOKEN_VARS.brandAccent);
    }
    if (branding.fontFamily) {
        root.style.setProperty('--font-family-sans', branding.fontFamily);
    }
    if (branding.fontFamilyMono) {
        root.style.setProperty('--font-family-mono', branding.fontFamilyMono);
    }
}
//# sourceMappingURL=index.js.map